var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDK_NAME = "sentry.javascript.browser";
exports.SDK_VERSION = "5.15.4"; //# sourceMappingURL=version.js.map

export default exports;